import "./Footer.scss";
import help from "../../assets/images/help-clean.png";
import hope from "../../assets/images/hope-edited.png";
import music from "../../assets/images/treble-clef-no-bgd.jpg";
import { Link } from "react-router-dom";
import { FaRegCopyright } from "react-icons/fa";

function Footer() {
  return (
    <section className="footer">
      <ul className="footer__nav">
        <Link to={"/MedHelp"} className="footer__nav-item-help">
          <li>
            <img src={help} className="footer__help-icon" alt="music"></img>
            GetHelp
          </li>
        </Link>

        <Link to={"/stories"} className="footer__nav-item-story">
          <li>
            <img src={hope} className="footer__hope-icon" alt="hope"></img>
            Stories
          </li>
        </Link>

        <Link to={"/songs"} className="footer__nav-item-music">
          <li>
            <img src={music} className="footer__music-icon" alt="music"></img>
            Rhythms
          </li>
        </Link>
      </ul>
      <p className="footer__copyright">
        <FaRegCopyright /> 2025 WithLoveFromCee | All Rights Reserved
      </p>
      <Link to={"/disclaimer"}>
        <button className="footer__disclaimer-btn">Disclaimer</button>
      </Link>
    </section>
  );
}

export default Footer;
